import { StatScores } from "./StatScores";

// TODO Check deze waarden, zelf bedacht
const legend = [
  { low: 0, name: "Stil", color: "#3C5941" },
  { low: 2, name: "Bijna stil", color: "#5E7658" },
  { low: 3, name: "Hoorbaar", color: "#819470" },
  {
    low: 4.5,
    name: "Goed hoorbaar",
    color: "#A7B38A",
  },
  { low: 6, name: "Geluid", color: "#D0D2A6" },
  {
    low: 8,
    name: "Storend geluid",
    color: "#FBF2C4",
  },
  { low: 10, name: "Veel geluid", color: "#E0B881" },
  { low: 12, name: "Ernstige overlast", color: "#D7995E" },
];

const mapping = {
  buren: "Burenoverlast",
  vlieg: "Vliegverkeer",
  trein: "Treinverkeer",
  weg: "Wegverkeer",
  weg_meer50: "Weg > 50m",
  weg_min50: "Weg < 50m",
};
export const Hinder = ({ stats }: { stats: Record<string, number> }) => {
  /*
  Eigen straat:

  ehinder_buren: 5.9,
  ehinder_vlieg: 1.4,
  ehinder_trein: 0.3,
  ehinder_weg: 6.4,
  ehinder_weg_meer50: 5.3,
  ehinder_weg_min50: 4.1

  Centrum:

  ehinder_buren: 11.7,
  ehinder_vlieg: 1.8,
  ehinder_trein: 0.9,
  ehinder_weg: 11.9,
  ehinder_weg_meer50: 2.7,
  ehinder_weg_min50: 11
   */
  if (!stats.ehinder_buren) return null;
  const calculated = {
    ...stats,
    ehinder_score: Object.keys(mapping).reduce(
      (acc, attr) => Math.max(stats[`ehinder_${attr}`], acc),
      0
    ),
  };
  return (
    <StatScores
      stats={calculated}
      prefix="ehinder_"
      mapping={mapping}
      title="Geluidshinder"
      legend={legend}
    />
  );
};
